export default __webpack_public_path__ + "static/media/cny-check-in.95267106.gif";